import { render, staticRenderFns } from "./ClientPage.vue?vue&type=template&id=5e4eb7a6&scoped=true"
import script from "./ClientPage.vue?vue&type=script&lang=js"
export * from "./ClientPage.vue?vue&type=script&lang=js"
import style0 from "./ClientPage.vue?vue&type=style&index=0&id=5e4eb7a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4eb7a6",
  null
  
)

export default component.exports